// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/Account/components/LoyaltyButton/LoyaltyButton.css
// module id = 470
// module chunks = 0